export default __webpack_public_path__ + "static/media/Ass_4.61194ae7.svg";